module.exports = __webpack_public_path__ + "assets/img/squ_jci.7c836ea0.jpg";